import S from 'constants/string.const';

export const QUESTION_TYPES = {
  SHORT_ANSWER: 'short_answer',
  LONG_ANSWER: 'long_answer',
  YES_NO: 'yes_no',
  CHECKBOXES: 'checkboxes',
  RADIO_BUTTONS: 'radio_buttons',
  DROPDOWN: 'dropdown',
  SIGNATURE: 'signature',
};

export const QUESTION_TYPE_LABELS = {
  [QUESTION_TYPES.SHORT_ANSWER]: 'consultationForms.questionTypes.short_answer',
  [QUESTION_TYPES.LONG_ANSWER]: 'consultationForms.questionTypes.long_answer',
  [QUESTION_TYPES.YES_NO]: 'consultationForms.questionTypes.yes_no',
  [QUESTION_TYPES.CHECKBOXES]: 'consultationForms.questionTypes.checkboxes',
  [QUESTION_TYPES.RADIO_BUTTONS]: 'consultationForms.questionTypes.radio_buttons',
  [QUESTION_TYPES.DROPDOWN]: 'consultationForms.questionTypes.dropdown',
  [QUESTION_TYPES.SIGNATURE]: 'consultationForms.questionTypes.signature',
};

export const MULTI_OPTION_TYPES = [QUESTION_TYPES.CHECKBOXES, QUESTION_TYPES.RADIO_BUTTONS, QUESTION_TYPES.DROPDOWN];

export const FORM_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  DRAFT: 'draft',
};

export const FORM_STATUS_LABELS = {
  [FORM_STATUS.ACTIVE]: 'consultationForms.status.active',
  [FORM_STATUS.INACTIVE]: 'consultationForms.status.inactive',
  [FORM_STATUS.DRAFT]: 'consultationForms.status.draft',
};

export const BUILDER_STEPS = [
  { number: 1, label: 'consultationForms.builder.steps.formBuilder' },
  { number: 2, label: 'consultationForms.builder.steps.setRules' },
  { number: 3, label: 'consultationForms.builder.steps.review' },
];

export const FORM_TEMPLATES = [
  {
    id: 'general_health',
    nameKey: 'consultationForms.templates.generalHealth.name',
    subtitleKey: 'consultationForms.templates.generalHealth.subtitle',
    questionCount: 6,
    icon: S.heartMending,
    questions: [
      { text: 'Do you have any known allergies?', type: QUESTION_TYPES.LONG_ANSWER, required: true },
      { text: 'Are you currently taking any medications?', type: QUESTION_TYPES.YES_NO, required: true },
      { text: 'Do you have any skin conditions?', type: QUESTION_TYPES.YES_NO, required: true },
      { text: 'Are you currently pregnant or breastfeeding?', type: QUESTION_TYPES.YES_NO, required: true },
      { text: 'Do you have any heart conditions?', type: QUESTION_TYPES.YES_NO, required: false },
      { text: 'Have you had any recent surgeries?', type: QUESTION_TYPES.YES_NO, required: false },
      { text: 'Do you have diabetes?', type: QUESTION_TYPES.YES_NO, required: false },
      { text: 'Any additional health information we should know?', type: QUESTION_TYPES.LONG_ANSWER, required: false },
    ],
  },
  {
    id: 'laser_treatment',
    nameKey: 'consultationForms.templates.laserTreatment.name',
    subtitleKey: 'consultationForms.templates.laserTreatment.subtitle',
    questionCount: 6,
    icon: S.writingHand,
    questions: [
      { text: 'Have you had laser treatment before?', type: QUESTION_TYPES.YES_NO, required: true },
      { text: 'Are you currently using retinoids or AHAs?', type: QUESTION_TYPES.YES_NO, required: true },
      {
        text: 'Have you been exposed to sun or used tanning beds in the last 2 weeks?',
        type: QUESTION_TYPES.YES_NO,
        required: true,
      },
      { text: 'Do you have a history of keloid scarring?', type: QUESTION_TYPES.YES_NO, required: true },
      { text: 'Are you taking any photosensitive medications?', type: QUESTION_TYPES.YES_NO, required: true },
      { text: 'Please describe your skin type', type: QUESTION_TYPES.SHORT_ANSWER, required: false },
    ],
  },
  {
    id: 'massage_therapy',
    nameKey: 'consultationForms.templates.massageTherapy.name',
    subtitleKey: 'consultationForms.templates.massageTherapy.subtitle',
    questionCount: 6,
    icon: S.heartHands,
    questions: [
      { text: 'Do you have any areas of pain or tension?', type: QUESTION_TYPES.LONG_ANSWER, required: true },
      { text: 'Do you have any injuries we should be aware of?', type: QUESTION_TYPES.YES_NO, required: true },
      {
        text: 'What pressure level do you prefer?',
        type: QUESTION_TYPES.RADIO_BUTTONS,
        required: true,
        options: ['Light', 'Medium', 'Firm', 'Deep'],
      },
      { text: 'Are you pregnant?', type: QUESTION_TYPES.YES_NO, required: true },
      { text: 'Any areas to avoid during massage?', type: QUESTION_TYPES.LONG_ANSWER, required: false },
    ],
  },
  {
    id: 'aftercare',
    nameKey: 'consultationForms.templates.aftercare.name',
    subtitleKey: 'consultationForms.templates.aftercare.subtitle',
    questionCount: 6,
    icon: S.clipboardDocument,
    questions: [
      { text: 'I understand the aftercare instructions provided', type: QUESTION_TYPES.YES_NO, required: true },
      { text: 'I agree to follow the recommended aftercare routine', type: QUESTION_TYPES.YES_NO, required: true },
      { text: 'Any concerns about aftercare?', type: QUESTION_TYPES.LONG_ANSWER, required: false },
      { text: 'Client signature', type: QUESTION_TYPES.SIGNATURE, required: true },
    ],
  },
  {
    id: 'scratch',
    nameKey: 'consultationForms.templates.scratch.name',
    subtitleKey: 'consultationForms.templates.scratch.subtitle',
    questionCount: 0,
    icon: S.plusEmoji,
    questions: [],
  },
];
